import { useCallback, useMemo } from 'react'
import {
  checkProductUnitAndSequenceDifferences,
  createProductGroupMap,
  extractUniqueProducts,
  getAllProductsAtQuays
} from 'src/pages/configuration/utils'
import { Config } from 'src/types'

export default function useExtractProductFromConfig(config: Config | null) {
  const products = useMemo(() => {
    return getAllProductsAtQuays(config?.quays)
  }, [config?.quays])
  const uniqueProducts = useMemo(() => {
    return extractUniqueProducts(products)
  }, [products])
  const productUnitAndSequenceDifferences = useMemo(() => {
    return checkProductUnitAndSequenceDifferences(uniqueProducts)
  }, [uniqueProducts])
  const productGroupMap = useMemo(() => {
    return createProductGroupMap(uniqueProducts)
  }, [uniqueProducts])

  const getQuayNameBasedOnProductNameAndGroup = useCallback(
    (productName: string, productGroup: string) => {
      return products.find(product => product.product === productName && product.productGroup === productGroup)
        ?.quayName
    },
    [products]
  )

  const getHolderNamesBasedOnProductNameAndGroup = useCallback(
    (productName: string, productGroup: string, productUnit?: string) => {
      // return as array of unique holder names and type
      // example output: [{ name: 'jetty 1', type: 'jetty' }, { name: 'mobru 2', type: 'mobru' }]
      let sortedProducts = products.filter(
        product => product.product === productName && product.productGroup === productGroup
      )
      if (productUnit) {
        sortedProducts = sortedProducts.filter(product => product.productUnit === productUnit)
      }
      const seen = new Set()
      const unique = sortedProducts.filter(item => {
        const key = `${item.mobruName || item.jettyName}|${item.holderType}`
        if (seen.has(key)) {
          return false
        }
        seen.add(key)
        return true
      })
      return unique.map(item => ({ name: item.mobruName || item.jettyName, type: item.holderType }))
    },
    [products]
  )

  return {
    products,
    uniqueProducts,
    productUnitAndSequenceDifferences,
    productGroupMap,
    getQuayNameBasedOnProductNameAndGroup,
    getHolderNamesBasedOnProductNameAndGroup
  }
}
